import { Injectable } from '@angular/core';

import { Api10ClubIdBlockedslotPostRequestParams, CreateBlockedSlotModel } from '@bayclubs/court-booking-employee-api';
import { TimeService } from '@bayclubs/ui-core';
import { BlockedSlotSaveFormModel } from '../models/blocked-slot-save-form.model';

@Injectable({
    providedIn: 'root'
})
export class BlockedSlotSaveMapperService {

    constructor(private timeService: TimeService) { }

    public createSaveCommand(model: BlockedSlotSaveFormModel): Api10ClubIdBlockedslotPostRequestParams {
        const result = {
            clubId: model.clubId,
            createBlockedSlotModel: {
                courtId: model.courtId,
                date: model.date,
                note: model.note,
                timeFromInMinutes: model.timeFromInMinutes,
                timeToInMinutes: model.timeToInMinutes,
                typeCode: model.typeCode,
                recurring: model.recurring != null ? {
                    endsCode: model.recurring.endsCode,
                    endingDate: model.recurring.endingDate != null ? this.timeService.toBcDate(model.recurring.endingDate).value : null,
                    occurrenceCount: model.recurring.occurrenceCount,
                    daysOfWeek: model.recurring.daysOfWeek
                } : null
            } as CreateBlockedSlotModel

        } as Api10ClubIdBlockedslotPostRequestParams;

        return result;
    }
}
